import { CdkConnectedOverlay } from '@angular/cdk/overlay'
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  InputSignal,
  OnInit,
  ViewEncapsulation,
  inject,
  input,
  model,
} from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { NavigationEnd, Router } from '@angular/router'

import { filter } from 'rxjs/operators'

import { FlxButtonModule, FlxIconModule } from '@flowx/angular-ui-toolkit'
import {
  fadeInBottom,
  fadeInLeft,
} from '@flowx/designer/shared/components/overlay/overlay-animations'

@Component({
  selector: 'flx-overlay',
  templateUrl: 'overlay.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [CdkConnectedOverlay, FlxButtonModule, FlxIconModule],
  styleUrls: ['overlay.component.scss'],
  animations: [fadeInBottom, fadeInLeft],
})
export class FlxOverlayComponent implements OnInit {
  #router = inject(Router)
  #destroyRef = inject(DestroyRef)
  overlayOrigin: InputSignal<any> = input(null)
  showOverlay = model(false)
  origin: InputSignal<'top' | 'left' | 'bottom' | 'right'> = input('bottom')
  dismissible: InputSignal<boolean> = input(true)
  closeOnBackdropClick: InputSignal<boolean> = input(false)

  ngOnInit(): void {
    this.#router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe(() => {
        this.showOverlay.set(false)
      })
  }

  overlayKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.showOverlay.set(false)
    }
  }
  onFakeBackdropClick(): void {
    if (this.closeOnBackdropClick()) {
      this.showOverlay.set(false)
    }
  }
}
